function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  viewBox: "0 0 512 512"
}, props), React.createElement("path", {
  d: "M15 210L255 15l241 195zm0 91l240 195 241-195z",
  strokeLinecap: "round",
  strokeWidth: "30",
  stroke: "#000"
})));